<template>
    <Card :title="$t('labels.order_statuses')">
        <div class="card-body">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'OrderStatusCreatePage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ translate('buttons.create') }}
            </router-link>
            <router-link
                class="btn btn-link legitRipple"
                :to="{ name: 'OrderStatusesSettingsPage' }"
            >
                <i class="icon-gear mr-2"></i>
                {{ $t('buttons.settings') }}
            </router-link>
        </div>
        <div class="table-responsive">
            <table class="table table-fixed">
                <thead>
                    <tr>
                        <th width="50px"></th>
                        <th width="300px">{{ $t('table.titles.id') }}</th>
                        <th width="300px">{{ $t('labels.name') }}</th>
                        <th width="300px">{{ $t('labels.type') }}</th>
                        <th width="300px">{{ $t('labels.color') }}</th>
                    </tr>
                </thead>
                <tbody is="vue:VueDraggableNext" v-model="statuses" tag="tbody" handle=".drag-handle" :animation="150" :force-fallback="true" @start="onDragStart" @end="onDragEnd">
                    <tr v-for="status in statuses" :key="status.id">
                        <td>
                            <i class="icon-menu7 drag-handle text-muted cursor-pointer"></i>
                        </td>
                        <td>
                            <router-link :to="{
                                name: 'OrderStatusEditPage',
                                params: {
                                    orderStatusUuid: status.uuid
                                }
                            }">
                                {{ status.id }}
                            </router-link>
                        </td>
                        <td>{{ status.name }}</td>
                        <td>{{ $t(`orderStatus.types.${status.type}`) }}</td>
                        <td>
                            <span class="badge" :style="{
                                'color': 'white',
                                'background-color': status.color
                            }">{{ $t('labels.color') }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AlphaButton from "../../../../components/new/button/AlphaButton.vue";
import DateFormatter from "../../../../services/DateFormatter";
import { VueDraggableNext } from "vue-draggable-next";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "OrderStatuses",
    components: {
        Card, AlphaButton, VueDraggableNext
    },
    data() {
        return {
            DateFormatter,
            statuses: []
        }
    },
    methods: {
        onDragStart() {
            document.body.style.cursor = 'move';
            document.body.style.userSelect = 'none';
        },
        onDragEnd() {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            this.updatePriorityStatuses();
        },
        updatePriorityStatuses() {
            const uuids = this.statuses.map(status => status.uuid);
            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/statuses/priority`, { uuids });
        },
        fetchStatuses() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/statuses`,
                {
                    orders: [
                        {
                            column: 'priority_order',
                            dir: 'asc'
                        }
                    ],
                    limit: 100
                }
            )
                .then(response => {
                    this.statuses = response.data.data;
                })
        }
    },
    mounted() {
        this.fetchStatuses();
    }
}
</script>
